export default __webpack_public_path__ + "static/media/serviciosAlarma2.6fd7a1a1.png";